import React from 'react';

// material ui compnents
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

// icons
import CloseIcon from '@mui/icons-material/Close';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// internal imports
import { grey } from 'assets/colors/colors';
import { Box } from 'components/base/layout/Box';
import MuiButton from 'components/__v5__/Button/MuiButton';
import { WarningModalProps } from './types/warningModal.types';
import {
  dialogContentStyles,
  dialogIconStyles,
  dialogTitleStyles,
} from './styles/warningModalStyles';

const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  dialogTitle,
  handleClose = () => {},
  handleSubmit = () => {},
  dialogIcon,
  dialogContent,
  cancelButtonLabel = 'Cancel',
  confirmButtonLabel = 'Confirm',
  showDialogActions = true,
  showInfoIcon = false,
}) => {
  const handleIconDisplay = () => {
    if (dialogIcon) {
      return dialogIcon;
    }
    if (showInfoIcon) {
      return <InfoOutlinedIcon sx={dialogIconStyles} />;
    }
    return <CardGiftcardIcon sx={dialogIconStyles} />;
  };

  const handleSubmitClick = () => {
    handleClose();
    handleSubmit();
  };
  return (
    <Dialog open={isOpen} fullWidth>
      <DialogTitle sx={{ position: 'relative', width: '100%' }}>
        <Typography sx={dialogTitleStyles}>{dialogTitle}</Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute !important',
            right: 15,
            top: 15,
            color: grey.g500,
            width: '24px',
            height: '24px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={dialogContentStyles}>
          <Box>{handleIconDisplay()}</Box>
          <Box>{dialogContent}</Box>
        </Box>
      </DialogContent>
      {showDialogActions && (
        <DialogActions>
          <MuiButton variant="outlined" color="secondary" onClick={handleClose}>
            {cancelButtonLabel}
          </MuiButton>
          <MuiButton variant="contained" onClick={handleSubmitClick}>
            {confirmButtonLabel}
          </MuiButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default WarningModal;
